import { Typography } from '../../../components/typography/typography';
import { Field } from '../../../components/field/field';
import { Button } from '../../../components/form/button';
import { useOutletContext } from 'react-router-dom';
import { AdminViewContext } from './admin-user-view';
import { useAdminFormState } from '../hooks/use-admin-form-state';
import { useAdminOperations } from '../hooks/use-admin-operations';

export const AdminUserSetup = () => {
  const { admin } = useOutletContext<AdminViewContext>();

  const {
    // Form state
    adminUsername,
    adminFullName,
    adminEmail,
    isDisabled,

    // Form actions
    setUsername,
    setFullname,
    setEmail,
  } = useAdminFormState({
    admin,
    type: 'setup',
  });

  const { updateUser, isUpdating } = useAdminOperations();

  const handleSubmit = async () => {
    await updateUser(admin.adminId, {
      adminUsername,
      adminEmail,
      adminFullName,
    });
  };

  return (
    <div className="tab-section">
      <div className="tab-title">
        <Typography type="text-xl" weight="semi-bold">
          Admin User Setup
        </Typography>
      </div>

      <div className="card">
        <div className="w-full">
          <Field
            className="w-full"
            type="text"
            label="Full name"
            value={adminFullName}
            onChange={(fullname: string) => {
              setFullname(fullname);
            }}
            isRequired={true}
            dataCy="admin-fullname"
          />
          <Field
            className="w-full"
            type="text"
            label="Primary email"
            value={adminEmail}
            onChange={(email: string) => {
              setEmail(email);
            }}
            isRequired={true}
            dataCy="admin-email"
          />
          <Field
            className="w-full"
            type="text"
            label="User name"
            value={adminUsername}
            onChange={(username: string) => {
              setUsername(username);
            }}
            isRequired={true}
            dataCy="admin-username"
          />
        </div>

        <div className="dialog-actions !px-0 !pb-0">
          <div className="flex flex-col sm:flex-row justify-end">
            <Button
              className="button button-yellow button-primary mb-2"
              onClick={handleSubmit}
              disabled={isDisabled}
              dataCy="save-changes"
            >
              <Typography type="text-sm" weight="semi-bold" className="text-quipli-black-800">
                {isUpdating ? 'Saving...' : 'Save changes'}
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
